import {Form} from 'antd';
import TextArea from 'antd/lib/input/TextArea';

import {useLocale} from '../../../../../../provider/locale/locale-hook';
import {BulkEditFieldNameEnum} from '../../../../../../service/company/company-type';
import {BaseCompanyFormItemPropsType} from '../company-form-items-type';

type PropsType = BaseCompanyFormItemPropsType<BulkEditFieldNameEnum.shortDescription> & {
    className?: string;
};

export function ShortDescriptionFormItem(props: PropsType): JSX.Element {
    const {value, onChange, className, errorMessage} = props;

    const {getLocalizedString} = useLocale();

    return (
        <Form.Item help={errorMessage} validateStatus={errorMessage ? 'error' : ''}>
            <TextArea
                className={className}
                maxLength={200}
                onChange={(event) => onChange(event.currentTarget.value)}
                placeholder={getLocalizedString('ADDITIONAL_INFO__SHORT_DESCRIPTION__PLACEHOLDER')}
                showCount
                value={value}
            />
        </Form.Item>
    );
}
